import OnePlatformCommonActions from "@frameworks/web/redux/actions/common/commonActions";
import { CONTRACT_COMMODITY } from "@frameworks/web/redux/interfaces/Reports/iContractCommodity";
class ContractCommodityActions extends OnePlatformCommonActions {
    getContractCommodity(contractCommodity, type) {
        this.dispatch({
            type: CONTRACT_COMMODITY,
            payload: { contractCommodity },
            reducerName: type,
        });
    }
}
export default ContractCommodityActions;
